import React from 'react';
import { connect } from 'react-redux';
import { FieldArray, getFormValues, reduxForm } from 'redux-form';
import { Box, Button } from '../../../../common/components';
import { compose } from 'redux';
import { Form, Row, Col } from 'react-bootstrap';
import { InternalButtonBar } from '../../../layout/components';
import { getFormattedInsurers } from '../../helpers';
import InsurerCommissionTable from '../BrokerForm/components/tabsContent/components/InsurerCommissionTable/InsurerCommissionTable';

const FORM_NAME = 'BrokerCommissionForm';

const BrokerCommissionForm = ({
  handleSubmit,
  submitting,
  isTracking,
  onUpdateCommission,
  availableProducts,
  formValues,
}) => {
  return (
    <Box>
      <Form onSubmit={handleSubmit(onUpdateCommission)}>
        <Row>
          <Col sm={12}>
            <h2 className="page-title">Insurer Commissions</h2>
          </Col>
        </Row>

        {formValues?.meta.commissions?.map((comm, index) => {
          const product = availableProducts.find(
            (product) => comm.product === product.id,
          );
          if (product) {
            return (
              <>
                <FieldArray
                  productName={product.name}
                  name={`meta.commissions.${index}.rates`}
                  component={InsurerCommissionTable}
                  availableProducts={availableProducts}
                />
              </>
            );
          }
        })}

        <Row>
          <Col xs={12}>
            <InternalButtonBar
              buttons={[
                {
                  permissions: ['broker.edit'],
                  button: (
                    <Button
                      className="pull-right"
                      type="submit"
                      bsStyle="primary"
                      label={
                        isTracking
                          ? 'Save Tracking Link Commissions'
                          : 'Save Broker Commissions'
                      }
                      isLoading={submitting}
                    />
                  ),
                },
              ]}
            />
          </Col>
        </Row>
      </Form>
    </Box>
  );
};

const getInitialValues = (resource, activeCommissions, insurers) => () => {
  return {
    meta: {
      commissions: getFormattedInsurers(activeCommissions, insurers),
    },
    data: {
      attributes: {
        total_commission_overrides:
          resource.data.attributes?.total_commission_overrides ?? {},
      },
    },
  };
};

export default compose(
  connect((state, ownProps) => {
    return {
      initialValues: getInitialValues(
        ownProps.resource,
        ownProps.activeCommissions,
        ownProps.insurers,
      )(state),
      formValues: getFormValues(FORM_NAME)(state),
    };
  }),
  reduxForm({
    form: FORM_NAME,
  }),
)(BrokerCommissionForm);
